import { render, staticRenderFns } from "./CertSave.vue?vue&type=template&id=c6d0fb76&scoped=true&"
import script from "./CertSave.vue?vue&type=script&lang=js&"
export * from "./CertSave.vue?vue&type=script&lang=js&"
import style0 from "./CertSave.vue?vue&type=style&index=0&id=c6d0fb76&prod&lang=scss&scoped=true&"
import style1 from "./CertSave.vue?vue&type=style&index=1&id=c6d0fb76&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6d0fb76",
  null
  
)

export default component.exports